module.exports = __webpack_public_path__ + "img/GHS-pictogram-rondflam.57ba9780.png";